import React, {Component} from "react"
import {Divider, Header, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import {SupportEmailLink} from "./base";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

class PasswordResetRequestSent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: null,
            success: false
        };
    }

    render() {
        const {loading} = this.state
        return (
            <React.Fragment>
                <CustomGrid container stackable centered fitted={'horizontally'}>
                    <CustomGrid.Column style={{marginTop: '8em'}} width={6}>
                        <Segment style={{padding: '2em 4em 2em 4em'}} loading={loading}>
                            <S3Image {...IMAGE.CHECK}/>
                            <Header as={"h3"} textAlign={"center"}>Your request was sent</Header>
                            <p className={"small"}>Check your email. If we have an account associated with that email, you’ll receive a
                                link to reset your password.</p>

                            <Divider hidden/>
                        </Segment>
                        <Segment basic style={{padding: '1em 4em'}}>
                            <p className={"smaller"}>Still need help? Reach out to our concierge team at <span
                                style={{whiteSpace: "nowrap"}}>{STRATEGIC_PARTNER.CONTACT_SUPPORT.NUMBER}</span> or <SupportEmailLink /></p>
                        </Segment>
                    </CustomGrid.Column>
                </CustomGrid>
            </React.Fragment>
        )
    }
}

export default withRouter(PasswordResetRequestSent);
